import { useMemo } from "react";
import useMitreCategories from "security-app/components/SecurityEvents/Alerts/MitreCategories/useMitreCategories";
const useMitreTechniques = (tactics) => {
  const { data, isInitialLoading } = useMitreCategories();
  const uppercaseTactics = useMemo(() => {
    var _a;
    return (_a = tactics == null ? void 0 : tactics.map((tactic) => tactic.toLocaleUpperCase())) != null ? _a : [];
  }, [tactics]);
  const techniques = useMemo(
    () => {
      var _a;
      return (_a = data == null ? void 0 : data.tactics) == null ? void 0 : _a.filter((row) => uppercaseTactics.length > 0 ? uppercaseTactics.includes(row.id) : true).flatMap((tactic) => tactic.techniques).flatMap((technique) => [technique, ...technique.subtechniques]).map(({ id, name }) => [id, name]);
    },
    [data == null ? void 0 : data.tactics, uppercaseTactics]
  );
  return {
    techniques,
    isLoadingTechniques: isInitialLoading
  };
};
export default useMitreTechniques;
